import { shade } from "polished";
import {
  newBorder,
  white,
  primary,
  textSecondary,
  hoverItemColor,
  textPrimary,
} from "../../utils/colors";
import useIsMobile from "../../hooks/useIsMobile";

const isError = false;

export const customSelectStyles = {
  placeholder: (provided) => ({
    ...provided,
    color: "#718096", // Change this to your desired placeholder color
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
    backgroundColor: white,
    border: `1px solid ${newBorder}`,
    fontSize: "0.875rem",
    fontWeight: "500",
    minHeight: "3rem",
    height: "3rem",
    margin: "0",
    padding: "0 8px",
    borderRadius: "0.75rem",

    ":focus-visible": {
      borderColor: primary,
      boxShadow: `0 0 0 1px ${newBorder}`,
    },
    ":hover": {
      boxShadow: "none",
      outline: "none",
      cursor: "pointer",
      borderColor: "#cbd5e0",
    },
  }),

  menu: (provided) => ({
    ...provided,
    borderRadius: "0.75rem",
    boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.3)",
    border: `0px solid ${newBorder}`,
    overflow: "hidden",
    zIndex: 90000,
  }),

  menuList: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    border: "none",
    boxShadow: "none",
  }),

  singleValue: (provided, state) => ({
    ...provided,
    opacity: state.isDisabled ? 0.5 : 1,
    color: textPrimary,
    margin: "0",
    padding: "0 0px",

    ":hover": {
      bg: "red",
    },
  }),

  option: (provided, state) => ({
    ...provided,

    // backgroundColor: state.isFocused ? backgroundLight : null,
    backgroundColor: state.isSelected ? primary : white, // Background color of selected option
    // color: state.isFocused ? textPrimary : state.data.color,
    color: state.isSelected ? "white" : textSecondary, // Color of text in options
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    margin: "0",
    padding: "0 1rem",
    fontWeight: "500",
    height: "48px",
    fontSize: "0.875rem",
    borderBottom: `1px solid ${newBorder}`,
    ":hover": {
      backgroundColor: state.isSelected ? shade(0.1, primary) : hoverItemColor,
      color: state.isSelected ? "white" : textPrimary,
    },
  }),
  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: primary,
    color: white,
    fontSize: "0.938rem",
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    color: state.data.color,
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    ":hover": {
      backgroundColor: state.data.bgDark,
      color: state.data.color,
    },
  }),
  groupHeading: (provided) => ({
    ...provided,
    fontSize: "11px",
    color: textSecondary,
    fontWeight: "500",
  }),
};
